import React from "react";
import { Box, Button, Typography } from "@mui/material";
import produce from "immer";
import CloseIcon from "@mui/icons-material/Close";
import { tl } from "../../../components/translate";
import QuestionnairePopUp from "./QuestionnairePopUp";
import { QUESTIONNAIRE } from "./QuestionnaireRow";
import { Questionnaire } from "../../../interfaces/AssessmentInterfaces";
import useAssessmentLabel from "../../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

function applyQuestionnaireTypes(assessmentQuestionnaire: Questionnaire[]): Questionnaire[] {
  return assessmentQuestionnaire?.map((item) => {
    const relatedType =
      QUESTIONNAIRE.find((question) => question.name === item.name)?.type || "text";
    return { ...item, type: relatedType };
  });
}

const QuestionnaireResponse = ({
  assessmentQuestionnaire,
  onChange
}: {
  assessmentQuestionnaire: Questionnaire[];
  onChange: (data: Questionnaire[]) => void;
}): React.ReactNode => {
  const assessmentLabels = useAssessmentLabel();

  // state
  const [showDialog, setShowDialog] = React.useState(false);

  // variables
  const previousQuestionnaire = applyQuestionnaireTypes(assessmentQuestionnaire);

  return (
    <Box className={styles.assessmentRow} height="auto" alignItems="flex-start">
      <Box className={styles.assessmentLabel} pt="4px">
        <Typography component="span" fontWeight="600">
          {assessmentLabels.questionnaire}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        {previousQuestionnaire?.map((v, index) => (
          <Box key={v.name} display="flex" justifyContent="space-between">
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography>{`${v.name}`}: </Typography>
              <Typography sx={{ fontWeight: 600 }}>{`${v.reading} ${v.unit}`}</Typography>
            </Box>
            <CloseIcon
              data-testmation="questionnaire.RemoveButton"
              style={{ cursor: "pointer" }}
              onClick={() => {
                const updatedQuestionnaire = produce(previousQuestionnaire, (draft) => {
                  draft.splice(index, 1);
                });
                onChange(updatedQuestionnaire);
              }}
            />
          </Box>
        ))}

        <Button
          onClick={() => setShowDialog(true)}
          data-testmation="questionnaire.AddNewButton"
          size="small"
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            marginTop: previousQuestionnaire.length > 0 ? 1 : 0
          }}
        >
          {tl("assessment.addNew")}
        </Button>
      </Box>
      <QuestionnairePopUp
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        previousQuestionnaire={previousQuestionnaire}
        onSave={onChange}
      />
    </Box>
  );
};

export default QuestionnaireResponse;
